import { render, staticRenderFns } from "./SurveyQuestionModal.vue?vue&type=template&id=2582692c&scoped=true&"
import script from "./SurveyQuestionModal.vue?vue&type=script&lang=ts&"
export * from "./SurveyQuestionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2582692c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardActions,VIcon})
